/**
 * Single source of truth for "is this lock locked?".
 *
 * Reads the canonical `lockState` string ('locked' | 'unlocked' | 'unknown')
 * and falls back to the legacy `isLocked` boolean for payloads from older
 * hubs. Every lock-state read in the web app must go through here so a future
 * `unknown`/`jammed` state is handled in one place rather than re-derived (and
 * mis-derived) at each component.
 */
export function isLockedOf(lock) {
  if (!lock) return false;
  if (lock.lockState) return lock.lockState === 'locked';
  return !!lock.isLocked;
}
